import React from "react";
import Header from "../components/layout/Header";
import { Sidebar } from "../components/layout/Sidebar";
import { PageWrapper } from "../components/layout/PageWrapper";
import CompanyForm from "../components/company/CompanyForm";
import { useThemeToggle } from "../hooks/useThemeToggle";
import { Link } from "react-router-dom";

export default function AddNewCompany() {
  useThemeToggle();

  return (
    <div className="main-wrapper">
      <Header />
      <Sidebar />
      <PageWrapper>
        {/* Back Button */}
        <div className="mb-3">
          <Link to="/admin/company-list" className="btn btn-turquoise">
            <i className="bi bi-arrow-left"></i> Back to List
          </Link>
        </div>

        {/* Form */}
        <CompanyForm />
      </PageWrapper>
    </div>
  );
}
